import React, {useRef} from 'react';
import {createRoot} from 'react-dom/client';

import './common/styles/index.scss';
import CartSelect from "./common/components/CartSelect";
import i18n from "./i18n";
import { I18nextProvider } from 'react-i18next';
import GreenCycleToggle from "./common/components/green_cycle_toggle/GreenCycleToggle";

const App = () => {
    const hasAccount = typeof window.Liferay.CommerceContext.account !== "undefined";

    return (
        <>
            {hasAccount === true ? <CartSelect/> : <span>No account available</span>
            }
        </>
    );
};
const GreenCycleToggleApp = () => {
        return <GreenCycleToggle/>
};

class WebComponent extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);
        this.root.render(
            <I18nextProvider i18n={i18n}>
                <App/>
            </I18nextProvider>);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}
class GreenCycleWebComponent extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);
        this.root.render(
            <I18nextProvider i18n={i18n}>
                <GreenCycleToggleApp/>
            </I18nextProvider>);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}

const ELEMENT_ID = 'up2date-cart-select';
const GREEN_CYCLE_TOGGLE_ELEMENT_ID = 'up2date-green-cycle-toggle';

if (!customElements.get(ELEMENT_ID)) {
    customElements.define(ELEMENT_ID, WebComponent);
}
if (!customElements.get(GREEN_CYCLE_TOGGLE_ELEMENT_ID)) {
    customElements.define(GREEN_CYCLE_TOGGLE_ELEMENT_ID, GreenCycleWebComponent);
}
